import { DatePicker, DatePickerProps } from 'antd';
import dayjs from 'dayjs';
import * as React from 'react';
import { useInputController } from '../hooks/useInputController';
import { useFormItemAccessibility } from '../item/useFormItemAccessibility';
import { useFormItemEnabled } from '../item/useFormItemEnabled';

export type IYearInputProps = DatePickerProps & {
  name: string;
  /**
   * Aggungiamo proprietà readOnly non gestita da antd
   * (gestita solo sul campi input con proprietà inputReadOnly)
   * per i campi di tipo data
   */
  readOnly?: boolean;
};

/**
 * Campo per input anno.
 */
export function YearInput(props: IYearInputProps) {
  const { name, inputReadOnly, readOnly, ...inputProps } = props;

  const { enabled, layoutEnabled } = useFormItemEnabled();

  const {
    field: { value, onChange, onBlur, ref },
  } = useInputController(name, { enabled });

  const accessibility = useFormItemAccessibility();

  return (
    <DatePicker
      size="large"
      picker="year"
      ref={ref}
      style={{ width: '100%' }}
      disabled={enabled === false || layoutEnabled === false}
      {...accessibility.attributes}
      {...inputProps}
      value={value ? dayjs().year(value) : undefined}
      onBlur={onBlur}
      name={name}
      onChange={value => onChange(value?.year() ?? null)}
      inputReadOnly={readOnly}
      // se il campo è readonly non mostriamo il pannello di selezione
      panelRender={readOnly ? panelProps => null : undefined}
    />
  );
}
